// extracted by mini-css-extract-plugin
export default {"wrapper":"HightLightProduct_wrapper__gO1Gb","container":"HightLightProduct_container__TsyRT","titleContainer":"HightLightProduct_titleContainer__VVrCz"};